var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOmgevingsvergunningen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5469 83.4531C10.2344 79.1406 13.0938 70.0937 10.8906 64.7969C8.6875 59.5 0.25 54.8594 0.25 49C0.25 43.1406 8.59375 38.6875 10.8906 33.2031C13.1875 27.7188 10.2344 18.8594 14.5469 14.5469C18.8594 10.2344 27.9063 13.0938 33.2031 10.8906C38.5 8.6875 43.1406 0.25 49 0.25C54.8594 0.25 59.3125 8.59375 64.7969 10.8906C70.2812 13.1875 79.1406 10.2344 83.4531 14.5469C87.7656 18.8594 84.9063 27.9063 87.1094 33.2031C89.3125 38.5 97.75 43.1406 97.75 49C97.75 54.8594 89.4063 59.3125 87.1094 64.7969C84.8125 70.2812 87.7656 79.1406 83.4531 83.4531C79.1406 87.7656 70.0937 84.9063 64.7969 87.1094C59.5 89.3125 54.8594 97.75 49 97.75C43.1406 97.75 38.6875 89.4063 33.2031 87.1094C27.7188 84.8125 18.8594 87.7656 14.5469 83.4531Z",
    fill: "#FDC100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.625 37.75L42.1094 64L28.375 50.875",
    stroke: "#445C7A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmgevingsvergunningen);
export default __webpack_public_path__ + "static/media/omgevingsvergunningen.0f1210ebdf6d9956f3b2d286df900f6c.svg";
export { ForwardRef as ReactComponent };